import gql from 'graphql-tag'

export const GET_EVENT_SPONSORS = gql`
  query GetEventSponsors($eventId: ID!) {
    getEventSponsors(eventId: $eventId) {
      id
      name
      logo
      sponsorLink
    }
  }
`

export const CREATE_EVENT_SPONSOR = gql`
  mutation CreateEventSponsor($eventId: ID!, $input: CreateEventSponsorInput!) {
    createEventSponsor(eventId: $eventId, input: $input) {
      id
    }
  }
`

export const UPDATE_EVENT_SPONSOR = gql`
  mutation UpdateEventSponsor($eventId: ID!, $id: ID!, $input: UpdateEventSponsorInput!) {
    updateEventSponsor(eventId: $eventId, id: $id, input: $input) {
      id
    }
  }
`

export const DELETE_EVENT_SPONSOR = gql`
  mutation DeleteEventSponsor($eventId: ID!, $id: ID!) {
    deleteEventSponsor(eventId: $eventId, id: $id)
  }
`
